import { render } from "./류마티스내과.vue?vue&type=template&id=439b7f14"
import script from "./류마티스내과.vue?vue&type=script&lang=js"
export * from "./류마티스내과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__